import { ModalView } from "./view.js";

export class ModalController {
  constructor(_title, _content, _class, _statusHTML) {
    this.view = new ModalView();
    this.doms = this.view.createDoms();
    this.doms.titleText.innerHTML = _title;
    this.doms.titleStatus.innerHTML = _statusHTML || '';
    if (_statusHTML === undefined || _statusHTML === null || _statusHTML === '') {
      this.doms.titleText.setAttribute('style', 'grid-column: span 2;');
    }
    this.doms.content.innerHTML = _content;
    this.oncloseCallback = null;

    if (_class) {
      let cs = _class.split(' ');
      for (let i = 0; i < cs.length; i++) {
        this.doms?.window.classList.add(cs[i]);
      }
    }
    this.doms.close.onclick = this.close.bind(this);
    this.show();
  }

  show() {
    document.body.appendChild(this.doms.modal);
    setTimeout(() => {
      this.doms?.modal?.classList.add('active');
    }, 100);
  }

  close() {
    this.doms?.modal?.classList.remove('active');
    setTimeout(() => {
      if (this.doms && this.doms.modal) {
        document.body.removeChild(this.doms.modal);
      }
      this.doms = null;
    }, 500);
    if (this.oncloseCallback && typeof this.oncloseCallback == 'function') {
      this.oncloseCallback();
    }
  }

  setContent(_html) {
    this.doms.content.innerHTML = _html;
  }
}
